import {Component, inject, OnInit} from '@angular/core';
import {CommonModule, Location} from '@angular/common';
import {
    DxButtonModule,
    DxLoadPanelModule,
    DxNumberBoxModule,
    DxScrollViewModule,
    DxToolbarModule
} from "devextreme-angular";
import {
    IFacilityCapacityDto,
    InventoryClient,
    UpdateFacilityCapacityCommand
} from '@services';
import notify from "devextreme/ui/notify";

@Component({
    selector: 'app-facility-capacity',
    imports: [
        CommonModule,
        DxToolbarModule,
        DxButtonModule,
        DxLoadPanelModule,
        DxNumberBoxModule,
        DxScrollViewModule
    ],
    templateUrl: './facility-capacity.component.html',
    styleUrl: './facility-capacity.component.scss',
})
export class FacilityCapacityComponent implements OnInit {
    private inventoryClient = inject(InventoryClient);
    private location = inject(Location);

    protected capacity: IFacilityCapacityDto = {};
    protected isLoading = false;

    ngOnInit(): void {
        this.loadCapacity();
    }

    private loadCapacity() {
        this.isLoading = true;
        this.inventoryClient.getFacilityCapacity().subscribe({
            next: (data) => {
                this.capacity = data;
                this.isLoading = false;
            },
            error: () => {
                notify('Failed to load facility capacity', 'error', 3000);
                this.isLoading = false;
            }
        });
    }

    cancel() {
        this.location.back();
    }

    save() {
        const command = new UpdateFacilityCapacityCommand({
            ambientCapacity: this.capacity.ambientCapacity,
            coolerCapacity: this.capacity.coolerCapacity
        });

        this.inventoryClient.updateFacilityCapacity(command).subscribe({
            next: () => {
                notify('Facility capacity updated successfully', 'success', 3000);
            },
            error: () => {
                notify('Failed to update facility capacity', 'error', 3000);
            }
        });
    }
}

